import API from './axios.js';

export const uploadftpfile = (uploadftppayload) =>API.post(`/ftp/upload`,uploadftppayload);
export const viewftpfile = (viewPath) =>API.get(`ftp/view/${viewPath}`);
export const downloadftpfile = (downloadPath) =>API.get(`/ftp/download/${downloadPath}`);